import { _localGet, _localSet } from 'utils/helpers/gimHelper';

const STORAGE_KEY = 'objectDiscussionSort';

/** newest — нові зверху, як віддає API. oldest — старі зверху. */
export type DiscussionSort = 'newest' | 'oldest';

export const readDiscussionSort = (): DiscussionSort => {
    try {
        const raw = _localGet(STORAGE_KEY) as string | null | undefined;
        return raw === 'oldest' ? 'oldest' : 'newest';
    } catch {
        return 'newest';
    }
};

export const writeDiscussionSort = (sort: DiscussionSort) => {
    try {
        _localSet(STORAGE_KEY, sort);
    } catch {
        /* localStorage може бути недоступний */
    }
};
